import React, { useEffect, useRef } from 'react';
import CreateButton from '../CreateButton/CreateButton';
import Task from '../Task/Task';
import { task_t } from '../../logic/types';
import { Draggable } from '../../helpers/Draggable.jsx';
import './tasks.scss';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
let dnd: Draggable;

const Tasks = ({ tasks }: { tasks: task_t[] }) => {
    let tasksEnd: React.RefObject<HTMLInputElement> = useRef(null);

    useEffect(() => {
        dnd = new Draggable(tasks);
        // if (tasksEnd.current) {
        //     tasksEnd.current.scrollIntoView({ behavior: 'smooth' });
        // }
    }, [tasks.length]);

    let createNewTask = () => {
        let newTask: task_t = {
            name: 'New Task',
            url: 'https://www.example.com',
            urlCheck: ['example.com'],
            desc: '',
            premium: false,
            ssMode: false,
            id: Date.now(),
        };
        if (!projectDetailsData.project) return;
        let cell = projectDetailsStore.getCurrentCell();
        if (cell === undefined) return;
        cell.tasks = [newTask, ...cell.tasks];
        projectDetailsData.project.cells = [...projectDetailsData.project.cells, cell];

        projectDetailsData.isDataSaved = false;
    };

    let onDragStart = (e: React.DragEvent<HTMLDivElement>, task: task_t): void => {
        if (dnd) dnd.onDragStart(e, task);
    };

    let onDrop = (e: React.DragEvent<HTMLDivElement>, task: task_t) => {
        if (dnd) dnd.onDrop(e, task);
        if (!projectDetailsData.project) return;
        let tasks = dnd.getElements();
        let cell = projectDetailsStore.getCurrentCell();
        if (!cell) return;
        cell.tasks = [...tasks];
        projectDetailsData.project.cells = [...projectDetailsData.project.cells, cell];
        projectDetailsData.isDataSaved = false;
    };
    
    return (
        <div className="tasks">
            <div className="tasks-header">
                <h5> Tasks </h5>
                <CreateButton onSubmit={createNewTask} />
            </div>
            
            {tasks.map((tsk: task_t, idx: number) => (
                <Task
                    task={tsk}
                    key={`${Math.floor(Math.random() * 100)}-${tsk.name}`}
                    onDragStart={onDragStart}
                    onDragOver={(e: React.DragEvent<HTMLDivElement>) => {
                        e.preventDefault();
                    }}
                    onDrop={onDrop}
                />
            ))}
            <div ref={tasksEnd}></div>
        </div>
    );
}

export default Tasks